/** Shared media-card dataflow handle anchor — vertical center of
 * header + preview/result region (NOT whole-card 50%). */

import type { CSSProperties } from 'react'

/** React inline styles that set Canvas shell CSS variables (TS 6-safe). */
export type PcvNodeShellCssVars = CSSProperties & {
  '--pcv-rail-top'?: string
  '--pcv-node-preview-height'?: string
}

export const MEDIA_CARD_HEADER_HEIGHT_PX = 34

export function mediaPreviewHandleTopPx(previewAreaHeightPx: number, headerHeightPx = MEDIA_CARD_HEADER_HEIGHT_PX): number {
  return (headerHeightPx + previewAreaHeightPx) / 2
}

export function mediaPreviewHandleTopCss(
  previewAreaHeightPx: number,
  headerHeightPx = MEDIA_CARD_HEADER_HEIGHT_PX,
): string {
  return `calc((${headerHeightPx}px + ${previewAreaHeightPx}px) / 2)`
}
